import { createValidator } from "../../utils/validation";
import { 
     
    riskAssesmentInfoSchema, 
    isIntermediaryName,
   
 } from "../validationRules/riskAssesmentInfoForm";

export const useValidateRiskAssessment = () => {
    const validateRiskAssesmemnt = (formData) => {
        let customValidator = {...riskAssesmentInfoSchema};
        console.log(" validation formData", formData);
        
       
        if (formData.InfluenceTransaction === "Yes") {
            customValidator = { ...customValidator, ...isIntermediaryName };
        }
       
        const validator = createValidator(customValidator);
        return validator(formData);
    }

    return { validateRiskAssesmemnt };
}